import {
  Col,
  message,
  PageHeader,
  Row,
  Spin,
  Select,
  Space,
  Tabs,
  Checkbox,
  Tag,
} from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  SelectItem,
  Form,
  FormItem,
  RangePickerItem,
  TableItem,
  dineroDisabledMask,
  ButtonItem,
  ErrorItem,
} from "../../../../Components/Items";
import { FileExcelOutlined } from "@ant-design/icons";
import * as XLSXStyle from "xlsx-js-style";
import moment from "moment";
import "moment/locale/es";
moment.locale("es");

const { Option } = Select;
const { TabPane } = Tabs;

// Colores por tipo de coincidencia — se usan tanto para el Tag en pantalla
// como para el relleno del Excel, para que ambas vistas coincidan.
const COLOR_SIN_RECEPCION = "FFC2D1"; // rojo/rosa claro — no se encontro ninguna recepcion
const COLOR_REUTILIZADA = "FFD9A8"; // naranja — caso importante: se repitio una recepcion ya asignada
const COLOR_SUGERIDA = "FFF3B0"; // amarillo — coincidencia heuristica, no confirmada
const COLOR_CONFIRMADA = "C6F6C3"; // verde — match confirmado (facturasPreviasMatcheadas)

class ReporteConciliacionCostosInternos extends Component {
  state = {
    loading: false,
    objetoProveedores: null,
    todasProveedores: null,
    dataReporte: null,
    todasCostos: [],
    desglosarRecepciones: false,
  };

  atras() {
    this.props.history.goBack();
  }

  async componentDidMount() {
    this.setState({ loading: true });
    await axios
      .post(
        "proveedores/selectProveedores",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasProveedores: res.data });
          this.setState({
            objetoProveedores: res.data.map((value) => (
              <Option value={value._id} key={value._id}>
                {value.nombre || value.razonSocial}
              </Option>
            )),
          });
        }
      });
    this.consultarReporteCostosInternos({
      periodo: [moment().subtract(1, "month"), moment()],
      proveedores: [],
    });
  }

  consultarReporteCostosInternos(values) {
    this.setState({ loading: true });
    axios
      .post(
        "reportesDeCompras/reporteCostosInternos",
        { ...values, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            loading: false,
            dataReporte: res.data,
            todasCostos: res.data.costos,
          });
        } else if (res.data.success === 1) {
          message.error("Ha sucedido un error y no se cargo bien el reporte");
        } else {
          message.error("Ha sucedido un error y no se cargo bien el reporte");
        }
        this.setState({ loading: false });
      });
  }

  // Texto condensado con todas las recepciones candidatas de la OC — marca
  // con ★ la que el reporte esta sugiriendo, sin decir que es definitiva.
  formatearCandidatas(recepcionesCandidatas) {
    if (!recepcionesCandidatas || recepcionesCandidatas.length === 0) return "";
    return recepcionesCandidatas
      .map(
        (c) =>
          `${c.elegido ? "★ " : ""}${c.folio || "(sin folio)"} (${c.fecha}, dif ${c.diferencia})`
      )
      .join(" · ");
  }

  coincidenciaInfo(row) {
    if (row.matchTipo === "confirmado") {
      return { color: "green", texto: "Confirmada" };
    }
    if (row.matchTipo === "sugerido" && row.movimientoReutilizado) {
      return { color: "orange", texto: "Reutilizada" };
    }
    if (row.matchTipo === "sugerido") {
      return { color: "gold", texto: "Sugerida" };
    }
    if (row.matchTipo === "alternativa") {
      return { color: "default", texto: "Opcion" };
    }
    return { color: "red", texto: "Sin recepcion" };
  }

  // Clase CSS por fila (reutiliza clases ya existentes en App.css) — se usa
  // tanto para el rowClassName de la tabla en pantalla como base del color
  // que se aplica en el Excel: verde = confirmada, rojo = sin recepcion,
  // naranja = reutilizada (importante, revisar), amarillo = sugerida.
  filaClaseCss(row, index) {
    if (row.matchTipo === "sinRecepcion") return "alta-importancia";
    if (row.matchTipo === "sugerido" && row.movimientoReutilizado) return "revisar";
    if (row.matchTipo === "sugerido" || row.matchTipo === "alternativa") return "saldoAFavorClassName";
    if (row.matchTipo === "confirmado") return "apartado";
    return index % 2 === 0 ? "zebra-gris" : "default";
  }

  // Fuente de datos compartida por la tabla en pantalla y el Excel: si el
  // checkbox "Desglosar Recepciones" esta activo, inserta despues de cada
  // factura una fila por cada recepcion candidata de su OC.
  construirFilas() {
    const { todasCostos, desglosarRecepciones } = this.state;
    const filasBase = todasCostos;
    if (!desglosarRecepciones) return filasBase;

    const filas = [];
    filasBase.forEach((row, idx) => {
      filas.push(row);
      const esUltimaDeLaFactura =
        idx === filasBase.length - 1 ||
        filasBase[idx + 1].facturaId !== row.facturaId;
      if (esUltimaDeLaFactura && row.recepcionesCandidatas && row.recepcionesCandidatas.length > 0) {
        row.recepcionesCandidatas.forEach((cand, cIdx) => {
          const filaCandidata = {
            _idSintetico: `${row.facturaId}-cand-${cIdx}`,
            esCandidata: true,
            facturaId: row.facturaId,
            fecha: cand.fecha,
            semana: "",
            proveedor: "↳ Posible recepcion",
            op: row.op,
            entrada: cand.folio,
            folioTipo: cand.folioTipo,
            responsable: "",
            factura: row.factura,
            fechaRecepcion: "",
            fechaFactura: "",
            mes: "",
            almacen: "",
            prodServ: "",
            cantMxn: 0,
            precioMxn: 0,
            subMxn: 0,
            ivaMxn: 0,
            retIva: 0,
            retIsr: 0,
            totalMxn: 0,
            cantUsd: 0,
            precioUsd: 0,
            subUsd: 0,
            ivaUsd: 0,
            totalUsd: 0,
            ministerio: "",
            descripcion: "",
            tipoCambio: 0,
            totalUsdConvertido: 0,
            totalCosto: 0,
            matchTipo: cand.elegido ? "sugerido" : "alternativa",
            diferenciaCantidad: cand.diferencia,
            recepcionesCandidatas: [],
            movimientoReutilizado: false,
          };
          filas.push(filaCandidata);
        });
      }
    });
    return filas;
  }

  descargarExcel() {
    const parseFecha = (val) => {
      if (!val) return val;
      const m = moment(val, "DD/MM/YYYY", true);
      return m.isValid() ? new Date(Date.UTC(m.year(), m.month(), m.date(), 12, 0, 0)) : val;
    };
    const round6Decimals = (num) => {
      if (typeof num !== "number") return num;
      const factor = 10 ** 6;
      const scaled = Number((num * factor).toPrecision(15));
      return Math.round(scaled) / factor;
    };

    const border = {
      top: { style: "thin", color: { auto: 1 } },
      bottom: { style: "thin", color: { auto: 1 } },
      left: { style: "thin", color: { auto: 1 } },
      right: { style: "thin", color: { auto: 1 } },
    };
    const headerStyle = {
      font: { bold: true, sz: 10, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "00BFD6" } },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border,
    };
    const columnasFecha = ["Fecha Mov.", "Fecha Rec. Factura", "Fecha Factura"];
    const columnasMoneda = [
      "Precio MXN", "Sub. MXN", "IVA MXN", "Ret IVA", "Ret ISR", "Total MXN",
      "Precio USD", "Sub. USD", "IVA USD", "Total USD", "Total USD (TC)", "Total Costo",
    ];

    const colorFila = (row) => {
      if (row.matchTipo === "sinRecepcion") return COLOR_SIN_RECEPCION;
      if (row.matchTipo === "sugerido" && row.movimientoReutilizado) return COLOR_REUTILIZADA;
      if (row.matchTipo === "sugerido" || row.matchTipo === "alternativa") return COLOR_SUGERIDA;
      if (row.matchTipo === "confirmado") return COLOR_CONFIRMADA;
      return null;
    };

    const celda = (value, columna, fill) => {
      const esFecha = columnasFecha.includes(columna);
      const esMoneda = columnasMoneda.includes(columna);
      const estilo = {
        alignment: {
          vertical: "center",
          horizontal: esMoneda ? "right" : undefined,
        },
        border,
        ...(esFecha ? { numFmt: "dd/mm/yyyy" } : {}),
        ...(esMoneda ? { numFmt: "0.000000" } : {}),
        ...(fill ? { fill: { fgColor: { rgb: fill } } } : {}),
      };
      if (esFecha && value instanceof Date) {
        return { v: value, t: "d", s: estilo };
      }
      return { v: value === null || value === undefined ? "" : value, s: estilo };
    };

    const columnas = [
      "Fecha Mov.", "Semana", "Proveedor", "O.C.", "Folio Movimiento", "Folio Movimiento Tipo",
      "Coincidencia", "Diferencia Cant.", "Recepciones Posibles",
      "Factura", "Fecha Rec. Factura", "Fecha Factura", "Mes", "Almacen", "Prod/Serv",
      "Cant MXN", "Precio MXN", "Sub. MXN", "IVA MXN", "Ret IVA", "Ret ISR", "Total MXN",
      "Cant USD", "Precio USD", "Sub. USD", "IVA USD", "Total USD",
      "Ministerio", "Descripcion", "T.C.", "Total USD (TC)", "Total Costo", "Responsable",
    ];

    const filas = this.construirFilas();
    const filasValores = filas.map((v) => {
      const { texto: coincidenciaTexto } = this.coincidenciaInfo(v);
      return {
        "Fecha Mov.": parseFecha(v.fecha),
        Semana: v.semana,
        Proveedor: v.proveedor,
        "O.C.": v.op,
        "Folio Movimiento": v.entrada,
        "Folio Movimiento Tipo": v.folioTipo,
        Coincidencia: coincidenciaTexto,
        "Diferencia Cant.": v.diferenciaCantidad === null || v.diferenciaCantidad === undefined ? "" : v.diferenciaCantidad,
        "Recepciones Posibles": this.formatearCandidatas(v.recepcionesCandidatas),
        Factura: v.factura,
        "Fecha Rec. Factura": parseFecha(v.fechaRecepcion),
        "Fecha Factura": parseFecha(v.fechaFactura),
        Mes: v.mes,
        Almacen: v.almacen,
        "Prod/Serv": v.prodServ,
        "Cant MXN": v.cantMxn,
        "Precio MXN": round6Decimals(v.precioMxn),
        "Sub. MXN": round6Decimals(v.subMxn),
        "IVA MXN": round6Decimals(v.ivaMxn),
        "Ret IVA": round6Decimals(v.retIva),
        "Ret ISR": round6Decimals(v.retIsr),
        "Total MXN": round6Decimals(v.totalMxn),
        "Cant USD": v.cantUsd,
        "Precio USD": round6Decimals(v.precioUsd),
        "Sub. USD": round6Decimals(v.subUsd),
        "IVA USD": round6Decimals(v.ivaUsd),
        "Total USD": round6Decimals(v.totalUsd),
        Ministerio: v.ministerio,
        Descripcion: v.descripcion,
        "T.C.": v.tipoCambio,
        "Total USD (TC)": round6Decimals(v.totalUsdConvertido),
        "Total Costo": round6Decimals(v.totalCosto),
        Responsable: v.responsable,
      };
    });

    const rows = [
      columnas.map((columna) => ({ v: columna, s: headerStyle })),
      ...filasValores.map((fila, idx) => {
        const fill = colorFila(filas[idx]);
        return columnas.map((columna) => celda(fila[columna], columna, fill));
      }),
    ];

    const worksheet = XLSXStyle.utils.aoa_to_sheet(rows);
    worksheet["!cols"] = columnas.map((columna) => ({
      wch: Math.max(columna.length + 2, 12),
    }));
    const workbook = XLSXStyle.utils.book_new();
    XLSXStyle.utils.book_append_sheet(workbook, worksheet, "Costos Internos");
    XLSXStyle.writeFile(
      workbook,
      `Reporte_Conciliacion_Costos_Internos_${moment().locale("es").format("L")}.xlsx`
    );
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  render() {
    const strSorter = (field) => (a, b) => {
      if (a[field] < b[field]) return -1;
      if (a[field] > b[field]) return 1;
      return 0;
    };
    const numSorter = (field) => (a, b) => (a[field] || 0) - (b[field] || 0);

    const columns = [
      {
        title: "Fecha Mov.",
        dataIndex: "fecha",
        key: "fecha",
        sorter: (a, b) =>
          moment(a.fecha, "DD/MM/YYYY") <
          moment(b.fecha, "DD/MM/YYYY")
            ? -1
            : 1,
        buscar: "fecha",
        ellipsis: true,
        width: 95,
      },
      {
        title: "Sem",
        dataIndex: "semana",
        key: "semana",
        sorter: numSorter("semana"),
        buscar: "semana",
        ellipsis: true,
        width: 60,
      },
      {
        title: "Proveedor",
        dataIndex: "proveedor",
        key: "proveedor",
        sorter: strSorter("proveedor"),
        buscar: "proveedor",
        ellipsis: true,
        width: 140,
      },
      {
        title: "O.C.",
        dataIndex: "op",
        key: "op",
        sorter: strSorter("op"),
        buscar: "op",
        ellipsis: true,
        width: 80,
      },
      {
        title: "Entrada",
        dataIndex: "entrada",
        key: "entrada",
        sorter: strSorter("entrada"),
        buscar: "entrada",
        ellipsis: true,
        width: 90,
      },
      {
        title: "Coincidencia",
        dataIndex: "matchTipo",
        key: "matchTipo",
        render: (_, record) => {
          const { color, texto } = this.coincidenciaInfo(record);
          return <Tag color={color}>{texto}</Tag>;
        },
        ellipsis: true,
        width: 110,
      },
      {
        title: "Diferencia Cant.",
        dataIndex: "diferenciaCantidad",
        key: "diferenciaCantidad",
        sorter: numSorter("diferenciaCantidad"),
        render: (value) => (value === null || value === undefined ? "-" : value),
        ellipsis: true,
        align: "right",
        width: 100,
      },
      {
        title: "Recepciones Posibles",
        dataIndex: "recepcionesCandidatas",
        key: "recepcionesCandidatas",
        render: (value, record) => record.esCandidata ? "" : this.formatearCandidatas(value),
        ellipsis: true,
        width: 260,
      },
      {
        title: "Factura",
        dataIndex: "factura",
        key: "factura",
        sorter: strSorter("factura"),
        buscar: "factura",
        ellipsis: true,
        width: 90,
      },
      {
        title: "Fecha Rec. Factura",
        dataIndex: "fechaRecepcion",
        key: "fechaRecepcion",
        sorter: (a, b) =>
          moment(a.fechaRecepcion, "DD/MM/YYYY") <
          moment(b.fechaRecepcion, "DD/MM/YYYY")
            ? -1
            : 1,
        buscar: "fechaRecepcion",
        ellipsis: true,
        width: 130,
      },
      {
        title: "Fecha Factura",
        dataIndex: "fechaFactura",
        key: "fechaFactura",
        sorter: (a, b) =>
          moment(a.fechaFactura, "DD/MM/YYYY") <
          moment(b.fechaFactura, "DD/MM/YYYY")
            ? -1
            : 1,
        buscar: "fechaFactura",
        ellipsis: true,
        width: 110,
      },
      {
        title: "Mes",
        dataIndex: "mes",
        key: "mes",
        sorter: strSorter("mes"),
        buscar: "mes",
        ellipsis: true,
        width: 80,
      },
      {
        title: "Proyecto",
        dataIndex: "almacen",
        key: "almacen",
        sorter: strSorter("almacen"),
        buscar: "almacen",
        ellipsis: true,
        width: 120,
      },
      {
        title: "Prod/Serv",
        dataIndex: "prodServ",
        key: "prodServ",
        sorter: strSorter("prodServ"),
        buscar: "prodServ",
        ellipsis: true,
        width: 100,
      },
      {
        title: "Cant MXN",
        dataIndex: "cantMxn",
        key: "cantMxn",
        sorter: numSorter("cantMxn"),
        render: (value) => !value ? "-" : value,
        ellipsis: true,
        align: "right",
        width: 90,
      },
      {
        title: "Precio MXN",
        dataIndex: "precioMxn",
        key: "precioMxn",
        sorter: numSorter("precioMxn"),
        render: (value) => !value ? "-" : dineroDisabledMask(value),
        ellipsis: true,
        align: "right",
        width: 100,
      },
      {
        title: "Sub. MXN",
        dataIndex: "subMxn",
        key: "subMxn",
        sorter: numSorter("subMxn"),
        render: (value) => !value ? "-" : dineroDisabledMask(value),
        ellipsis: true,
        align: "right",
        width: 100,
      },
      {
        title: "IVA MXN",
        dataIndex: "ivaMxn",
        key: "ivaMxn",
        sorter: numSorter("ivaMxn"),
        render: (value) => !value ? "-" : dineroDisabledMask(value),
        ellipsis: true,
        align: "right",
        width: 95,
      },
      {
        title: "Ret IVA",
        dataIndex: "retIva",
        key: "retIva",
        sorter: numSorter("retIva"),
        render: (value) => !value ? "-" : dineroDisabledMask(value),
        ellipsis: true,
        align: "right",
        width: 90,
      },
      {
        title: "Ret ISR",
        dataIndex: "retIsr",
        key: "retIsr",
        sorter: numSorter("retIsr"),
        render: (value) => !value ? "-" : dineroDisabledMask(value),
        ellipsis: true,
        align: "right",
        width: 90,
      },
      {
        title: "Total MXN",
        dataIndex: "totalMxn",
        key: "totalMxn",
        sorter: numSorter("totalMxn"),
        render: (value) => !value ? "-" : dineroDisabledMask(value),
        ellipsis: true,
        align: "right",
        width: 100,
      },
      {
        title: "Cant USD",
        dataIndex: "cantUsd",
        key: "cantUsd",
        sorter: numSorter("cantUsd"),
        render: (value) => !value ? "-" : value,
        ellipsis: true,
        align: "right",
        width: 90,
      },
      {
        title: "Precio USD",
        dataIndex: "precioUsd",
        key: "precioUsd",
        sorter: numSorter("precioUsd"),
        render: (value) => !value ? "-" : dineroDisabledMask(value),
        ellipsis: true,
        align: "right",
        width: 100,
      },
      {
        title: "Sub. USD",
        dataIndex: "subUsd",
        key: "subUsd",
        sorter: numSorter("subUsd"),
        render: (value) => !value ? "-" : dineroDisabledMask(value),
        ellipsis: true,
        align: "right",
        width: 95,
      },
      {
        title: "IVA USD",
        dataIndex: "ivaUsd",
        key: "ivaUsd",
        sorter: numSorter("ivaUsd"),
        render: (value) => !value ? "-" : dineroDisabledMask(value),
        ellipsis: true,
        align: "right",
        width: 90,
      },
      {
        title: "Total USD",
        dataIndex: "totalUsd",
        key: "totalUsd",
        sorter: numSorter("totalUsd"),
        render: (value) => !value ? "-" : dineroDisabledMask(value),
        ellipsis: true,
        align: "right",
        width: 100,
      },
      {
        title: "Ministerio",
        dataIndex: "ministerio",
        key: "ministerio",
        sorter: strSorter("ministerio"),
        buscar: "ministerio",
        ellipsis: true,
        width: 100,
      },
      {
        title: "Descripcion",
        dataIndex: "descripcion",
        key: "descripcion",
        sorter: strSorter("descripcion"),
        buscar: "descripcion",
        ellipsis: true,
        width: 200,
      },
      {
        title: "T.C",
        dataIndex: "tipoCambio",
        key: "tipoCambio",
        sorter: numSorter("tipoCambio"),
        render: (value) => !value ? "-" : value,
        ellipsis: true,
        align: "right",
        width: 80,
      },
      {
        title: "Total USD (TC)",
        dataIndex: "totalUsdConvertido",
        key: "totalUsdConvertido",
        sorter: numSorter("totalUsdConvertido"),
        render: (value) => !value ? "-" : dineroDisabledMask(value),
        ellipsis: true,
        align: "right",
        width: 115,
      },
      {
        title: "Total Costo",
        dataIndex: "totalCosto",
        key: "totalCosto",
        sorter: numSorter("totalCosto"),
        render: (value) => !value ? "-" : dineroDisabledMask(value),
        ellipsis: true,
        align: "right",
        width: 105,
      },
    ];

    return (
      <>
        <Form
          name="reporteConciliacionCostosInternos"
          onFinish={this.consultarReporteCostosInternos.bind(this)}
          onFinishFailed={this.onFinishFailed}
          initialValues={{
            periodo: [moment().subtract(1, "month"), moment()],
          }}
        >
          <PageHeader
            onBack={this.atras.bind(this)}
            title="Conciliacion Costos Internos"
            style={{
              border: "1px solid rgb(235, 237, 240)",
              backgroundColor: "white",
              marginBottom: 10,
            }}
            extra={
              <div style={{ display: "flex", justifyContent: "right" }}>
                <Space>
                  {this.state.dataReporte && (
                    <ButtonItem
                      blanco
                      onClick={() => this.descargarExcel()}
                      icon={<FileExcelOutlined />}
                      style={{ display: "block", margin: "0 0 0 auto" }}
                    >
                      Descargar Excel
                    </ButtonItem>
                  )}
                  <ButtonItem
                    type="primary"
                    htmlType="submit"
                    style={{ display: "block", margin: "0 0 0 auto" }}
                  >
                    Consultar
                  </ButtonItem>
                </Space>
              </div>
            }
          />
          <Spin spinning={this.state.loading}>
            <div
              style={{
                backgroundColor: "white",
                padding: 20,
                paddingTop: 5,
                borderRadius: 5,
                boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
              }}
            >
              <Tabs
                style={{ margin: 0 }}
                tabBarExtraContent={{
                  left: (
                    <h1 style={{ padding: 0, margin: "0 10px 0 0" }}>
                      Filtros:
                    </h1>
                  ),
                }}
              >
                <TabPane tabKey="1" key="1" forceRender tab="Periodo">
                  <FormItem
                   name="periodo"
                   required
                   noStyle
                   tooltip="El periodo filtra por fecha de recepción de factura"
                  >
                    <RangePickerItem />
                  </FormItem>
                </TabPane>
                <TabPane tabKey="2" key="2" forceRender tab="Proveedores">
                  <Row>
                    <Col span={16}>
                      <FormItem name="proveedores" noStyle margin>
                        <SelectItem
                          width="90%"
                          mode="multiple"
                          placeholder="Todos los proveedores"
                        >
                          {this.state.objetoProveedores}
                        </SelectItem>
                      </FormItem>
                    </Col>
                  </Row>
                </TabPane>
                <TabPane tabKey="3" key="3" forceRender tab="Opciones">
                  <Checkbox
                    checked={this.state.desglosarRecepciones}
                    onChange={(e) => this.setState({ desglosarRecepciones: e.target.checked })}
                  >
                    Desglosar Recepciones (una fila por cada recepcion candidata de la OC)
                  </Checkbox>
                </TabPane>
              </Tabs>
            </div>
            <TableItem
              rowKey={(record, index) => record._idSintetico || index}
              columns={columns}
              dataSource={this.construirFilas()}
              rowClassName={(record, index) => this.filaClaseCss(record, index)}
              size="small"
              pagination={false}
              scroll={{ x: 3100 }}
            />
          </Spin>
        </Form>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ReporteConciliacionCostosInternos);
